import { call, put, takeLatest, fork, all } from "redux-saga/effects";
import * as types from "../Action/actionTypes";
import * as basicDetailsAPI from "../../services/BasicDetailsAPI";
import {
    apiCallFailure,
    apiCallRequest,
    apiCallSuccess,
} from "../Action/Action";

// Worker saga
function* fetchEntraUsers(action: any): Generator {
    try {
        const searchText = action.payload;
        const response: any = yield call(
            basicDetailsAPI.fetchEntraUsers,
            searchText
        );
        // API call or business logic here
        if (response.status === 200) {
            yield put({
                type: types.GET_ENTRA_ID_USERS_SUCCESS,
                payload: response.data.result.value,
            });
        } else {
            yield put({
                type: types.GET_ENTRA_ID_USERS_FAILURE,
                payload: "",
            });
        }
    } catch (e) {
        yield put({ type: types.GET_ENTRA_ID_USERS_FAILURE, payload: e });
    }
}

function* getCountriesDropdown(): Generator {
    try {
        // API call or business logic here

        const response: any = yield call(basicDetailsAPI.CountriesDropdownApi);

        if (response.status === 200) {
            yield put({
                type: types.GET_BASIC_DETAILS_COUNTRIES_SUCCESS,
                payload: response.data.result,
            });
        } else {
            yield put({
                type: types.GET_BASIC_DETAILS_COUNTRIES_FAILURE,
                payload: "",
            });
        }
    } catch (e) {
        yield put({ type: types.GET_BASIC_DETAILS_COUNTRIES_FAILURE, payload: e });
    }
}

function* getSuppliersDropdown(): Generator {
    try {
        // API call or business logic here

        const response: any = yield call(basicDetailsAPI.SuppliersDropdownApi);

        if (response.status === 200) {
            yield put({
                type: types.GET_BASIC_DETAILS_SUPPLIERS_SUCCESS,
                payload: response.data.result,
            });
        } else {
            yield put({
                type: types.GET_BASIC_DETAILS_SUPPLIERS_FAILURE,
                payload: "",
            });
        }
    } catch (e) {
        yield put({ type: types.GET_BASIC_DETAILS_SUPPLIERS_FAILURE, payload: e });
    }
}

function* getCatagoriesDropdown(): Generator {
    try {
        // API call or business logic here

        const response: any = yield call(basicDetailsAPI.CatagoriesDropdownApi);

        if (response.status === 200) {
            yield put({
                type: types.GET_BASIC_DETAILS_CATAGORIES_SUCCESS,
                payload: response.data.result,
            });
        } else {
            yield put({
                type: types.GET_BASIC_DETAILS_CATAGORIES_FAILURE,
                payload: "",
            });
        }
    } catch (e) {
        yield put({ type: types.GET_BASIC_DETAILS_CATAGORIES_FAILURE, payload: e });
    }
}
function* getSalesRepLeadDropdown(action: any): Generator {
    try {
        // API call or business logic here
        const supplierId = action.payload;
        const response: any = yield call(
            basicDetailsAPI.SalesRepLeadDropdownApi,
            supplierId
        );

        if (response.status === 200) {
            yield put({
                type: types.GET_BASIC_DETAILS_SALESREPLEAD_SUCCESS,
                payload: response.data.result,
            });
        } else {
            yield put({
                type: types.GET_BASIC_DETAILS_SALESREPLEAD_FAILURE,
                payload: "",
            });
        }
    } catch (e) {
        yield put({
            type: types.GET_BASIC_DETAILS_SALESREPLEAD_FAILURE,
            payload: e,
        });
    }
}
function* getNegotiationData(): Generator {
    try {
        const response: any = yield call(basicDetailsAPI.getNegotiationData)
        if (response.status === 200) {
            yield put({ type: types.GET_BASIC_DETAILS_CATAGORIES_SUCCESS, payload: response.data.result });
        } else {
            yield put({ type: types.GET_BASIC_DETAILS_CATAGORIES_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put({ type: types.GET_BASIC_DETAILS_CATAGORIES_FAILURE, payload: e });
    }
}
function* createNewSupplier(data: any): Generator {
    try {
        yield put(apiCallRequest());
        // API call or business logic here

        const response: any = yield call(basicDetailsAPI.createNewSupplier, data)

        if (response.status === 200) {
            //based on the call type, we can handle the response differently
            if (data.payload.newSupplier.ID) {
                yield put(apiCallSuccess("Supplier updated successfully."));
            } else {
                yield put(apiCallSuccess("New supplier created successfully."));
            }
            yield put({ type: types.CREATE_NEW_SUPPLIER_SUCCESS, payload: response.result });
            yield put({ type: types.GET_BASIC_DETAILS_SUPPLIERS })
        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while creating a new supplier. Please try again."
                )
            );
            yield put({ type: types.CREATE_NEW_SUPPLIER_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while creating a new supplier. Please try again."
            )
        );
        yield put({ type: types.CREATE_NEW_SUPPLIER_FAILURE, payload: e });
    }
}

function* deleteSupplier(data: any): Generator {
    try {
        yield put(apiCallRequest());
        // API call or business logic here
        const response: any = yield call(basicDetailsAPI.deleteSupplier, data);
        if (response.data.statusCode === 200) {
            yield put(apiCallSuccess("Supplier deleted successfully."));
            yield put({ type: types.DELETE_SUPPLIER_SUCCESS, payload: response.result });
            yield put({ type: types.GET_BASIC_DETAILS_SUPPLIERS })
        } else if (response.data.statusCode === "409") {
            yield put(
                apiCallFailure(
                    "The selected supplier can not be deleted as it has been used in previous negotiation(s)"
                )
            );
            yield put({ type: types.DELETE_SUPPLIER_FAILURE, payload: "" });
        }
        else {
            yield put(
                apiCallFailure(
                    "An error occurred while deleting the supplier. Please try again."
                )
            );
            yield put({ type: types.DELETE_SUPPLIER_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while deleting the supplier. Please try again."
            )
        );
        yield put({ type: types.DELETE_SUPPLIER_FAILURE, payload: e });
    }
}

function* createNewSalesRepLead(data: any): Generator {
    try {
        yield put(apiCallRequest());
        // API call or business logic here

        const response: any = yield call(basicDetailsAPI.createNewSalesRepLead, data)

        if (response.status === 200) {
            //based on the call type, we can handle the response differently
            if (data.payload.newSalesRepLead.ID) {
                yield put(apiCallSuccess("Sales Rep Lead updated successfully."));
            } else {
                yield put(apiCallSuccess("New Sales Rep Lead created successfully."));
            }
            yield put({ type: types.CREATE_NEW_SALES_REP_LEAD_SUCCESS, payload: response.result });
            yield put({ type: types.GET_BASIC_DETAILS_SUPPLIERS })
        } else if (response.data.statusCode === 409) {
            yield put(
                apiCallFailure(
                    response?.data?.message
                )
            );
            yield put({ type: types.DELETE_SUPPLIER_FAILURE, payload: "" });
        }
        else {
            yield put(
                apiCallFailure(
                    "An error occurred while deleting the supplier. Please try again."
                )
            );
            yield put({ type: types.DELETE_SUPPLIER_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while creating a new Sales Rep Lead. Please try again."
            )
        );
        yield put({ type: types.CREATE_NEW_SALES_REP_LEAD_FAILURE, payload: e });
    }
}

function* deleteSalesRepLead(data: any): Generator {
    try {
        yield put(apiCallRequest());
        // API call or business logic here
        const response: any = yield call(basicDetailsAPI.deleteSalesRepLead, data);
        if (response.data.statusCode === 200) {
            yield put(apiCallSuccess("Sales Rep Lead deleted successfully."));
            yield put({ type: types.DELETE_SALES_REP_LEAD_SUCCESS, payload: response.result });
            yield put({ type: types.GET_BASIC_DETAILS_SUPPLIERS })
        } else if (response.data.statusCode === "409") {
            yield put(
                apiCallFailure(
                    response?.data?.message
                )
            );
            yield put({ type: types.DELETE_SALES_REP_LEAD_FAILURE, payload: "" });
        }
        else {
            yield put(
                apiCallFailure(
                    "An error occurred while deleting the Sales Rep Lead. Please try again."
                )
            );
            yield put({ type: types.DELETE_SALES_REP_LEAD_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while deleting the Sales Rep Lead. Please try again."
            )
        );
        yield put({ type: types.DELETE_SALES_REP_LEAD_FAILURE, payload: e });
    }
}

function* sendNegotiationData(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const data = action.payload;
        const response: any = yield call(basicDetailsAPI.sendNegotiationData, data);
        if (response.status === 200) {

            yield put(apiCallSuccess("Your changes have been saved successfully."));
            if (response.data?.message === "Negotiation created successfully") {
                yield put({
                    type: types.CREATE_NEGOTIATION_SUCCESS,
                    payload: {
                        state: true,
                        ID: response?.data?.result?.negotiationID, // Assuming the response contains the ID of the created negotiation
                    },
                });
            }
            if (action.meta?.onSuccess) {
                action.meta.onSuccess()
            }
        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while saving your changes. Please try again."
                )
            );
            if (action.meta?.onFailure) {
                action.meta.onFailure()
            }
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while saving your changes. Please try again."
            )
        );

        console.log(e);
        if (action.meta?.onFailure) {
            action.meta.onFailure()
        }
    }
}

// Worker saga
function* setFormState(action: any): Generator {
    try {

        yield put({
            type: types.CREATE_NEGOTIATION_SUCCESS,
            payload: action.payload,
        });
    } catch (e) {
        yield put({ type: types.CREATE_NEGOTIATION_FAILURE, payload: e });
    }
}

// Watcher saga
function* watchGetCountriesDropdown(): Generator {
    yield takeLatest(types.GET_BASIC_DETAILS_COUNTRIES, getCountriesDropdown);
}

function* watchfetchEntraUsers(): Generator {
    yield takeLatest(types.GET_ENTRA_ID_USERS, fetchEntraUsers);
}

function* watchCreateNewSupplier(): Generator {
    yield takeLatest(types.CREATE_NEW_SUPPLIER, createNewSupplier)
}
function* watchDeleteSupplier(): Generator {
    yield takeLatest(types.DELETE_SUPPLIER, deleteSupplier)
}
function* watchCreateNewSalesRepLead(): Generator {
    yield takeLatest(types.CREATE_NEW_SALES_REP_LEAD, createNewSalesRepLead);
}
function* watchDeleteSalesRepLead(): Generator {
    yield takeLatest(types.DELETE_SALES_REP_LEAD, deleteSalesRepLead);
}
function* watchGetCatagoriesDropdown(): Generator {
    yield takeLatest(types.GET_BASIC_DETAILS_CATAGORIES, getCatagoriesDropdown);
}
function* watchGetSalesRepLeadDropdown(): Generator {
    yield takeLatest(
        types.GET_BASIC_DETAILS_SALESREPLEAD,
        getSalesRepLeadDropdown
    );
}
function* watchGetSuppliersDropdown(): Generator {
    yield takeLatest(types.GET_BASIC_DETAILS_SUPPLIERS, getSuppliersDropdown);
}
function* watchSendNegotiationData(): Generator {
    yield takeLatest(types.POST_SAVE_FORM_DETAILS, sendNegotiationData);
}
function* watchSetFormState(): Generator {
    yield takeLatest(types.CREATE_NEGOTIATION, setFormState);
}

// Root saga
export default function* BasicDetailsSaga(): Generator {
    yield all([
        fork(watchGetCountriesDropdown),
        fork(watchfetchEntraUsers),
        fork(watchGetCatagoriesDropdown),
        fork(watchGetSalesRepLeadDropdown),
        fork(watchGetSuppliersDropdown),
        fork(watchSendNegotiationData),
        fork(watchCreateNewSupplier),
        fork(watchDeleteSupplier),
        fork(watchCreateNewSalesRepLead),
        fork(watchDeleteSalesRepLead),
        fork(watchSetFormState),
    ]);
}
